import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({ modules: null, vocabulary: {}, customFields: [], profession: "", loading: true, reload: () => {} });

export function BusinessProfileProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!localStorage.getItem("ced_token")) { setLoading(false); return; }
    try { const { data } = await api.get("/business-profile"); setProfile(data); }
    catch { /* ignore */ }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const value = {
    modules: profile?.modules || null,
    vocabulary: profile?.vocabulary || {},
    customFields: profile?.custom_fields || [],
    profession: profile?.profession || "",
    loading,
    reload: load,
  };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useProfile() { return useContext(Ctx); }

// A module is visible unless explicitly disabled (null profile => show all).
export function moduleEnabled(modules, key) { return !modules || modules[key] !== false; }
